// See error codes in https://github.com/MetaMask/eth-rpc-errors/blob/main/src/error-constants.ts
export const knownErrorCodes = [
  4001, 4100, 4200, 4900, 4901, -32700, -32600, -32601, -32602, -32603, -32000,
  -32001, -32002, -32003, -32004, -32005
]

const knownErrorMessages = [
  { code: 4001, partialErrorMessage: 'user canceled' }
]

export const isWalletTimeoutError = err =>
  err.message?.toLowerCase()?.includes('be aware that it might still be mined')

const signatureToCustomError = {
  '0xc724afdf': 'leverage-slippage-too-high',
  '0x177466fe': 'burn-amount-exceeds-balance',
  '0x5de1e541': 'amount-is-too-high'
}

const getErrorKey = function (err) {
  if (knownErrorCodes.includes(err.code)) {
    return `error-code${err.code}`
  }
  const knownError = knownErrorMessages.find(({ partialErrorMessage }) =>
    partialErrorMessage.includes(err?.message.toLowerCase())
  )
  if (knownError) {
    return `error-code${knownError.code}`
  }
  const customError = err.message.match('0x[a-fA-F0-9]+')?.[0]
  if (customError && signatureToCustomError[customError]) {
    return `error-custom-${signatureToCustomError[customError]}`
  }
}

export default getErrorKey
